import { formState } from "../../../modules/form/FormState";
import { FormService } from "../../services/FormService";
import { hideModal } from "../functions/modalFunctions";
import { getContactData } from "../interfaces/ContactProjectInterface";
/**
 * @description Class responsible for handling the form submission.
 */
class RecommendForm {
    // Constructor where the form state is initialized and methods are bound to the correct context
    constructor(formState) {
        this.formState = formState;
        // Bind methods to the correct context (this)
        this.submitForm = this.submitForm.bind(this);
    }
    /**
     * Method responsible for submitting the form with the gathered information.
     * @param contactModal - Identifier for the contact modal being used.
     */
    submitForm() {
        var _a, _b, _c, _d;
        const checkedItems = document.querySelectorAll('input.check-recommender:checked');
        let countCheck = checkedItems.length;
        const checkbox = document.getElementById('checkboxRecommend');
        let dataForm = getContactData();
        dataForm.contextReference = 'recomendador';
        dataForm.contextComponent = 'recomendador';
        if (checkbox.checked && countCheck != 0) {
            (_a = document.getElementById('checkboxRecommendError')) === null || _a === void 0 ? void 0 : _a.classList.add('d-none');
            (_b = document.getElementById('confirm-send-recommend')) === null || _b === void 0 ? void 0 : _b.classList.remove('d-none');
            checkedItems.forEach((input) => {
                const ID = input.value;
                dataForm.project_reference = parseInt(ID);
                dataForm.preferenceNode = parseInt(ID);
                const recommendId = input.getAttribute("recommended_id");
                const isFair = input.getAttribute("fair");
                if (recommendId) {
                    dataForm.contextReference = 'recomendador diamante';
                    dataForm.field_contact_product = Number(recommendId);
                }
                if (isFair == '1') {
                    dataForm.field_contact_product = 3;
                }
                const UrlApi = '/api/ev-lead';
                const sendForm = new FormService(formState);
                sendForm.sendLead(UrlApi, dataForm);
                setTimeout(() => {
                    hideModal('modalRecommend');
                }, 2000);
            });
        }
        else {
            if (!checkbox.checked) {
                checkbox.classList.add('invalid');
            }
            if (countCheck == 0) {
                (_c = document.getElementById('checkboxRecommendError')) === null || _c === void 0 ? void 0 : _c.classList.remove('d-none');
            }
            else {
                (_d = document.getElementById('checkboxRecommendError')) === null || _d === void 0 ? void 0 : _d.classList.add('d-none');
            }
        }
    }
}
// Exporting the class for use in other modules
export { RecommendForm };
